// AdsDetail.jsx
import { CiHeart } from "react-icons/ci";
import { AiFillHeart } from "react-icons/ai";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Breadcrumb from './models/Breadcrumb';
import ContactModal from "./models/ContactModal";
import AdsDetailSkeleton from './AdsDetailSkeleton';
import { useParams } from "react-router-dom";
import AdsService from "../../../services/Ads.js";
import DefaultImage from '../ads/modules/Images/DefaultImage.png'
import { formatNumberForDisplay } from "../../../utiels/functions/persianFormat.js";
import EmptyStateMyLoads from "../../../Modals/empty list/EmptyList";
import { PiTruckLight } from "react-icons/pi";

export default function AdsDetail() {
    const { id } = useParams();
    const [ad, setAd] = useState(null);
    const [animate, setAnimate] = useState(false);
    const [mainImage, setMainImage] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLiked, setIsLiked] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchAd() {
            try {
                setLoading(true);
                const res = await AdsService.getAdById(id);
                const data = res?.data?.data;
                setIsLiked(data?.isSaved)
                setAd(data);

                setMainImage(
                    Array.isArray(data?.image) && data?.image?.length > 0
                        ? `https://barsaraa.maksiran.ir${data?.image[0]?.path}`
                        : data?.image?.path
                            ? `https://barsaraa.maksiran.ir${data?.image?.path}`
                            : DefaultImage
                );
            } catch (err) {
                console.error("Error fetching ad:", err);
            }
            finally {
                setLoading(false);
            }
        }
        fetchAd();
    }, [id]);


    console.log("Ad fetched:", ad);


    const handleLike = async () => {
        try {
            const body = {
                rentalSaleId: id

            }
            if (isLiked) {
                await AdsService.disLikeAd(body);
            } else {
                await AdsService.likeAd(body);
            }
            setIsLiked(prev => !prev);
            console.log("Ad liked status:", !isLiked);
        } catch (err) {
            console.error("Error liking ad:", err);
        }
    };

    console.log(ad)


    const breadcrumbItems = [
        { label: "خانه", to: "/" },
        { label: "آگهی‌ها", to: "/ads" },
        { label: "جزئیات آگهی", to: `/ads/${id}`, active: true }
    ];
    console.log("adsssddd:", ad);

    // if (!ad) return <AdsDetailSkeleton />;

    if (loading ) return (
        <div className="w-full flex flex-col gap-10 lg:h-[calc(100vh-10rem)] overflow-y-auto py-10 lg:px-10 px-5">
            <AdsDetailSkeleton count={6} />
        </div>
    )

    if(ad===undefined || ad==null ||ad=={}){

        return(
          <div className="w-full flex flex-col gap-10 min-h-screen justify-center py-10 lg:px-10 px-5" dir="rtl">
    
          <EmptyStateMyLoads
          icon={PiTruckLight}
          colorContent="text-special"
          bgColor="transparent"
          title="آگهی مورد نظر یافت نشد!"
          subtitle="آگهی با شناسه وارد شده وجود ندارد!"
          ShowButton={false}
        >
    
    
        </EmptyStateMyLoads>
        </div>
    
    
        )
    
      }


    return (
        <motion.main
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="relative w-full min-h-screen py-24 md:py-40 px-4 sm:px-6 max-w-[1200px] mx-auto"
        >
            <Breadcrumb items={breadcrumbItems} />

            <div className="flex flex-col md:flex-row justify-center gap-10">
                {/* عکس‌ها */}
                <motion.div
                    initial={{ opacity: 0, x: 40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                    className="flex flex-col md:w-1/3 order-1 md:order-2"
                >
                    <div className="flex-col justify-center">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={mainImage}
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 1.05 }}
                                transition={{ duration: 0.2, ease: "easeOut" }}
                                className="w-full h-[300px] md:h-[200px] lg:h-[300px] rounded-2xl shadow-lg overflow-hidden flex items-center justify-center bg-gray-100"
                            >

                                {mainImage && (
                                    <motion.img
                                        src={mainImage || DefaultImage}
                                        alt="توضیحات آگهی"
                                        className={`w-full h-full object-cover cursor-pointer ${loading ? 'animate-pulse' : ''}`}
                                    />

                                )}
                            </motion.div>
                        </AnimatePresence>

                        <div className="flex w-full overflow-x-auto gap-2 mt-2 no-scrollbar">
                            {Array.isArray(ad?.image) ? (
                                ad.image.map((img, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: 0.1 * index }}
                                        className="relative flex-shrink-0"
                                    >
                                        <img
                                            src={`https://barsaraa.maksiran.ir${img?.path}`}
                                            alt={img.originalName || "image"}
                                            className="w-[85px] h-[85px] object-cover rounded-2xl cursor-pointer hover:scale-105 transition-transform"
                                            onClick={() => setMainImage(`https://barsaraa.maksiran.ir${img?.path}`)} 
                                        />
                                        {mainImage === `https://barsaraa.maksiran.ir${img?.path}` && (
                                            <motion.div
                                                layoutId="overlay"
                                                className="absolute inset-0 bg-black/50 rounded-2xl border-2"
                                            />
                                        )}
                                    </motion.div>
                                ))
                            ) : (
                                ad.image?.path && (
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1 }}
                                        className="relative flex-shrink-0"
                                    >
                                        <img
                                            src={`https://barsaraa.maksiran.ir${ad?.image?.path}`}
                                            alt={ad?.image?.originalName || "image"}
                                            className="w-[85px] h-[85px] object-cover rounded-2xl cursor-pointer hover:scale-105 transition-transform"
                                            onClick={() => setMainImage(`https://barsaraa.maksiran.ir${ad?.image?.path}`)}
                                        />
                                        {mainImage === `https://barsaraa.maksiran.ir${ad?.image?.path}` && (
                                            <motion.div
                                                layoutId="overlay"
                                                className="absolute inset-0 bg-black/50 rounded-2xl border-2"
                                            />
                                        )}
                                    </motion.div>
                                )
                            )}
                        </div>
                    </div>
                </motion.div>

                {/* توضیحات */}
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
                    className="flex flex-col md:w-1/2 pe-0 md:pe-16 order-2 md:order-1"
                >
                    <div className="flex justify-between">
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                            className="text-2xl font-bold"
                        >
                            {(ad?.car?.label || "-") + " " + (ad?.car?.name || "-")}

                        </motion.h2>

                        <motion.span
                            whileTap={{ scale: 0.8 }}
                            whileHover={{ scale: 1.2 }}
                            className={`flex items-center justify-center cursor-pointer transition-transform duration-300 ${animate ? "scale-125 animate-pulse" : ""
                                }`}
                            onClick={handleLike}
                        >
                            {isLiked ? (
                                <AiFillHeart className="w-7 h-7 text-red-600" />
                            ) : (
                                <CiHeart className="w-7 h-7 text-gray-500" />
                            )}
                        </motion.span>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.5 }}
                        className="bg-transparent rounded-lg p-5 my-8"
                    >
                        <h2 className="text-lg text-special font-medium mb-4">مشخصات</h2>
                        <div className="flex flex-col divide-y-[1px] divide-gray-300 gap-2 mb-4 w-full">
                            {[
                                ["نوع معامله", ad?.type === "rent" ? "اجاره" : ad?.type === "sales" ? "فروش" : ad?.type || "-"],
                                ["مدل", ad?.car?.label +"-" + ad?.car?.name|| "-"],
                                ["سال خودرو", ad?.productionYear || "-"],
                                // ["رنگ", ad?.color || "-"],
                                ["شهر",(ad?.city?.country?.name || ad?.city?.state?.name || "-")+","+ad?.city?.name || "-"]
                            ].map(([label, value], i) => (
                                <motion.div
                                    key={i}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4, delay: 0.6 + i * 0.1 }}
                                    className="flex flex-row justify-between pt-4 items-center w-full"
                                >
                                    <span className="text-xs text-gray-500">{label}</span>
                                    <span className="text-sm text-gray-800 font-medium break-words">{value}</span>
                                </motion.div>
                            ))}
                        </div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 1 }}
                            className="flex gap-3 items-center justify-between mt-5"
                        >
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="w-1/2 inline-flex justify-center items-center gap-2 bg-special text-white py-2 rounded-md text-sm hover:scale-105 transition-transform"
                            >
                                اطلاعات تماس
                            </button>
                            <span className="text-md text-gray-800 font-bold break-words">
                                {formatNumberForDisplay(ad?.price) || "تماس بگیرید"} تومان
                            </span>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 1.2 }}
                            className="flex-col justify-start items-center w-full mt-8"
                        >
                            <h2 className="text-lg text-gray-500 font-medium mb-4">توضیحات</h2>
                            <p className="text-gray-500 text-sm">{ad.description || "-"}</p>
                        </motion.div>
                    </motion.div>
                </motion.div>
            </div>

            <ContactModal phone={"0" + ad?.user?.mobile} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </motion.main>
    );
}
